function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M53.2114 9.0027V34.4057H46.353V9.0027H37.8252V2.91139H61.7392V9.0027H53.2114Z",
  fill: "black"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M65.0143 2.91139H76.8811C78.9566 2.91139 80.8517 3.24228 82.5663 3.90405C84.2809 4.56582 85.7398 5.55848 86.943 6.88202C88.1462 8.17549 89.0787 9.81488 89.7405 11.8002C90.4023 13.7554 90.7331 16.0416 90.7331 18.6586C90.7331 21.2756 90.4023 23.5767 89.7405 25.562C89.0787 27.5173 88.1462 29.1567 86.943 30.4802C85.7398 31.7737 84.2809 32.7513 82.5663 33.4131C80.8517 34.0748 78.9566 34.4057 76.8811 34.4057H65.0143V2.91139ZM76.8811 28.3144C78.9265 28.3144 80.5358 27.7429 81.709 26.5998C82.8821 25.4568 83.4687 23.6219 83.4687 21.0951V16.222C83.4687 13.6953 82.8821 11.8604 81.709 10.7173C80.5358 9.57423 78.9265 9.0027 76.8811 9.0027H71.8726V28.3144H76.8811Z",
  fill: "black"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M98.0367 8.19053C96.683 8.19053 95.6904 7.88972 95.0587 7.28811C94.4571 6.65642 94.1563 5.85928 94.1563 4.89671V3.90405C94.1563 2.94147 94.4571 2.15938 95.0587 1.55777C95.6904 0.926075 96.683 0.610229 98.0367 0.610229C99.3903 0.610229 100.368 0.926075 100.97 1.55777C101.601 2.15938 101.917 2.94147 101.917 3.90405V4.89671C101.917 5.85928 101.601 6.65642 100.97 7.28811C100.368 7.88972 99.3903 8.19053 98.0367 8.19053ZM94.6977 10.7173H101.376V34.4057H94.6977V10.7173Z",
  fill: "black"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M35.0373 17.8614C35.0373 27.2754 27.4057 34.907 17.9916 34.907C8.57758 34.907 0.94598 27.2754 0.94598 17.8614C0.94598 8.44733 8.57758 0.815735 17.9916 0.815735C27.4057 0.815735 35.0373 8.44733 35.0373 17.8614Z",
  fill: "#2D2BC6"
});

var _ref6 =
/*#__PURE__*/
React.createElement("g", {
  filter: "url(#filter0_d)"
}, React.createElement("path", {
  d: "M27.0158 17.8614C27.0158 22.8453 22.9755 26.8856 17.9916 26.8856C13.0077 26.8856 8.96745 22.8453 8.96745 17.8614C8.96745 12.8775 13.0077 8.83722 17.9916 8.83722C22.9755 8.83722 27.0158 12.8775 27.0158 17.8614Z",
  fill: "#3FF585"
}));

var _ref7 =
/*#__PURE__*/
React.createElement("g", {
  filter: "url(#filter1_d)"
}, React.createElement("path", {
  d: "M22.4293 17.8614C22.4293 20.3122 20.4425 22.299 17.9916 22.299C15.5408 22.299 13.554 20.3122 13.554 17.8614C13.554 15.4105 15.5408 13.4237 17.9916 13.4237C20.4425 13.4237 22.4293 15.4105 22.4293 17.8614Z",
  fill: "white"
}));

var _ref8 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  id: "filter0_d",
  x: 4.96745,
  y: 4.83722,
  width: 26.0483,
  height: 26.0483,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", null), React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.34 0"
}), React.createElement("feBlend", {
  mode: "color-burn",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), React.createElement("filter", {
  id: "filter1_d",
  x: 9.55396,
  y: 9.42371,
  width: 16.8753,
  height: 16.8753,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", null), React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.34 0"
}), React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

var SvgTdi = function SvgTdi(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 102,
    height: 35,
    viewBox: "0 0 102 35",
    fill: "none",
    ref: svgRef
  }, props), React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    }
  }, _ref2, _ref3, _ref4), _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTdi, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tdi.6735f0f0.svg";
export { ForwardRef as ReactComponent };